import TyGeneralCell from './TyGeneralCell.vue'
export default TyGeneralCell



// WEBPACK FOOTER //
// ./src/components/ty-general-cell/index.js